import React, { useEffect, useState } from "react";
import { ApiService, isFeatureEnabled } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";
import ProductImages from "../products/productImages";
import ProductVariants from "../products/productVariants";
import useDataFctory from "../useDataFactory";
import GTagsInput from "../gComponents/gTagsInput";
import Modal from "react-modal";
import LocalizationForm from "../forms/localizationForm";

var formTitle = {
  fontWeight: "400",
  margin: "20px 15px",
};

export default function ProductEditForm(props) {
  const [productBasicInfo, setProductBasicInfo] = useState({});
  const [productVariants, setProductVariants] = useState([]);
  const [productImages, setProductImgaes] = useState([]);
  const [variantTypeIndex, setVariantTypeIndex] = useState(0);
  const { data: categoriesList } = useDataFctory("product/group", false, {
    store_id: props.storeId,
  });
  const { data: classesData } = useDataFctory("tax_classes", false);
  const [openSnackbar] = useSnackbar();
  const [localizationsArray, setLocalizationsArray] = useState(
    props.data?.localizations || []
  );
  const [localizationVisible, setLocalizationVisible] = useState(false);
  const initialValues = {
    title: "",
    price: "",
    unit: "",
    categories: "",
    store_id: props.storeId,
    stock: 0,
    unlimited: 0,
    discount: 0,
    description: "",
    keywords: "",
    index: 0,
    barcode: "",
  };

  const getProductDetail = () => {
    ApiService({ method: "GET", route: "products/" + props.data.id }).then(
      (response) => {
        console.log("r" + response.data.status_code);
        if (response.data.status_code === 1) {
          setProductBasicInfo(response.data);
          initialValues.title = response.data.data.title;
          initialValues.price = response.data.data.price;
          initialValues.unit = response.data.data.unit;
          initialValues.categories = response.data.data.categories;
          initialValues.unlimited = response.data.data.unlimited;
          initialValues.stock = response.data.data.stock;
          initialValues.discount = response.data.data.discount;
          initialValues.description = response.data.data.description;
          initialValues.index = response.data.data.index;
          initialValues.barcode = response.data.data?.barcode || "";
          initialValues.tax_class_id = response.data.data?.tax_class_id || "";
          initialValues.keywords = response.data.data.keywords
            ? response.data.data.keywords.split(",")
            : [];
          setProductVariants(response.data.data.variants);
          setProductImgaes(response.data.data.images);
        } else {
          //openSnackbar(response.message);
          return;
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, []);

  const onSubmit = (values) => {
    console.log(values);
    values.stock = values.stock ? values.stock : "0";
    values.keywords =
      values.keywords.length > 0 ? values.keywords.toString() : "";
    values.localizations = localizationsArray;
    // return;
    ApiService({
      method: "PUT",
      route: "products/" + props.data.id,
      body: values,
    }).then((response) => {
      console.log("r" + response.data.status_code);
      if (response.data.status_code === 1) {
        props.setPevisible(false);
        props.onSubmit();
      }
      openSnackbar(response.data.message);
      return;
    });
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    price: Yup.string().required("Required"),
    unit: Yup.string().required("Required"),
    categories: Yup.string().required("Required"),
  });

  if (props.pevisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header"> Edit Product</div>
      <div className="modal-body">
        <h2 style={formTitle}>Basic Information</h2>

        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <FormikControl
                control="input"
                type="text"
                label="Title"
                name="title"
                divstyle={{
                  display: "inline-block",
                  width: "50%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />

              {categoriesList.length >= 0 ? (
                <FormikControl
                  control="selectGroup"
                  as="select"
                  label="Category"
                  name="categories"
                  options={categoriesList}
                  key_title="title"
                  key_value="id"
                  divstyle={{
                    display: "inline-block",
                    width: "50%",
                    boxSizing: "border-box",
                    verticalAlign: "top",
                  }}
                />
              ) : (
                ""
              )}

              <FormikControl
                control="input"
                type="text"
                label="Unit"
                name="unit"
                divstyle={{
                  display: "inline-block",
                  width: "33.3%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />
              <FormikControl
                control="input"
                type="text"
                label="Price"
                name="price"
                onChange={(event) => {
                  const re = /^[0-9.\b]+$/;
                  if (event.target.value && !re.test(event.target.value)) {
                    return;
                  } else {
                    setFieldValue("price", event.target.value);
                  }
                }}
                divstyle={{
                  display: "inline-block",
                  width: "33%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />

              <div
                style={{
                  display: "inline-block",
                  width: "33%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              >
                <FormikControl
                  control="input"
                  type="text"
                  label="Discount (in %)"
                  name="discount"
                  maxLength={3}
                  onChange={(event) => {
                    const re = /^[0-9.\b]+$/;
                    if (event.target.value && !re.test(event.target.value)) {
                      return;
                    } else {
                      setFieldValue("discount", event.target.value);
                    }
                  }}
                  divstyle={{
                    display: "inline-block",
                    width: "100%",
                    boxSizing: "border-box",
                    verticalAlign: "top",
                    margin: "0",
                  }}
                />
                <div
                  style={{
                    fontSize: "13px",
                    padding: "0px 15px",
                    color: "#555",
                  }}
                >
                  Old Price :{" "}
                  {values.discount >= 100
                    ? values.price
                    : ((100 * values.price) / (100 - values.discount)).toFixed(
                        "2"
                      )}
                </div>
              </div>

              <FormikControl
                control="input"
                type="text"
                label="Index"
                name="index"
                divstyle={{
                  display: "inline-block",
                  width: "40%",
                  boxSizing: "border-box",
                  verticleAlign: "top",
                }}
              />

              {props.isBarcodeShow == 1 && (
                <FormikControl
                  control="input"
                  type="text"
                  label="Barcode"
                  name="barcode"
                  divstyle={{
                    display: "inline-block",
                    width: "60%",
                    boxSizing: "border-box",
                    verticalAlign: "top",
                  }}
                />
              )}
              <FormikControl
                control="input"
                as="textarea"
                label="Description"
                name="description"
              />

              <FormikControl
                control="input"
                type="text"
                label="Keywords (Used In Product Search)"
                name="keywords"
              />
              {/* <div style={{ margin: "0 15px" }}>
                <label>Keywords (Used In Product Search)</label>
                <GTagsInput
                  data={keywords}
                  onChange={(data) => {
                    console.log(data);
                    values.keywords = data;
                    setFieldValue("keywords", data);
                    setKeywords(data);
                  }}
                />
                <br />
              </div> */}

              {props.isStockShow === "1" && (
                <>
                  <FormikControl
                    control="toggle"
                    label="Unlimited"
                    isToggled={values.unlimited == "1" ? 1 : 0}
                    name="unlimited"
                    onToggle={() => {
                      let unlimitedVal =
                        values.unlimited === "1" ? true : false;
                      unlimitedVal = !unlimitedVal;
                      unlimitedVal = unlimitedVal === true ? "1" : "0";
                      setFieldValue("unlimited", unlimitedVal);
                    }}
                    style={{
                      width: "25%",
                      boxSizing: "border-box",
                      verticleAlign: "top",
                    }}
                  />
                  {values.unlimited != "1" ? (
                    <FormikControl
                      control="input"
                      type="text"
                      label="Stock"
                      name="stock"
                      divstyle={{
                        display: "inline-block",
                        width: "35%",
                        boxSizing: "border-box",
                        verticleAlign: "top",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </>
              )}
              {isFeatureEnabled("tax_class_enabled") ? (
                <FormikControl
                  control="select"
                  as="select"
                  label="Tax Class"
                  name="tax_class_id"
                  placeholder={"Choose Tax Class"}
                  options={classesData}
                  key_title="title"
                  key_value="id"
                  divstyle={{
                    display: "inline-block",
                    verticalAlign: "top",
                    boxSizing: "border-box",
                    width: "40%",
                  }}
                />
              ) : (
                ""
              )}

              {props.settings?.locales &&
                props.settings?.locales.length > 0 && (
                  <div style={{ margin: "15px 15px" }}>
                    <label>Localizations</label>

                    {localizationsArray.length > 0 ? (
                      <GButton
                        variant="linkable"
                        onClick={() => setLocalizationVisible(true)}
                      >
                        {localizationsArray.length} Localizations added
                      </GButton>
                    ) : (
                      <GButton
                        variant="linkable"
                        children="+ Add Localization"
                        onClick={() => setLocalizationVisible(true)}
                      />
                    )}
                  </div>
                )}

              <h2 style={formTitle}>Product Images</h2>

              <div style={{ margin: "15px" }}>
                <ProductImages
                  onUpload={(data) => {
                    setProductImgaes([...productImages, data]);
                  }}
                  onRemove={(id) => {
                    setProductImgaes(
                      productImages.filter((item) => item.id !== id)
                    );
                  }}
                  productImages={productImages}
                  add={true}
                  productId={props.data.id}
                />
              </div>

              {productVariants && productVariants.length > 0 ? (
                <React.Fragment>
                  <h2 style={formTitle}>Product Variants</h2>
                  <div style={{ background: "#f8f9fd", padding: "15px" }}>
                    <ProductVariants
                      productVariants={productVariants}
                      productId={props.data.id}
                      setVariantTypeIndex={setVariantTypeIndex}
                      selectedIndex={variantTypeIndex}
                      handleVariantAdd={(index, data) => {
                        setVariantTypeIndex(index);
                        productVariants[index].options.push(data);
                        // setProductVariants(productVariants);
                      }}
                      handleVariantRemove={(index, i) => {
                        setVariantTypeIndex(index);
                        console.log(i);
                        productVariants[index].options.splice(i, 1);
                        setProductVariants(productVariants);
                      }}
                      isVarStockShow={props.isStockShow}
                    />
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              <br />
              <GButton
                variant="condensed"
                style={{
                  margin: "0 15px",
                  width: "95%",
                }}
                children={!props.isEmpty ? "Update" : "Create"}
                type="submit"
              />
            </Form>
          )}
        </Formik>
      </div>

      <Modal
        isOpen={localizationVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setLocalizationVisible(false)}
        style={{
          content: {
            width: "600px",
          },
        }}
        contentLabel="Localization Form Modal"
      >
        <LocalizationForm
          localizationVisible={localizationVisible}
          setLocalizationVisible={setLocalizationVisible}
          data={localizationsArray}
          onSubmit={(data) => {
            setLocalizationsArray([...data]);
          }}
          keyArray={
            props.localizableKeys || [
              { title: "Title", value: "title" },
              { title: "Unit", value: "unit" },
            ]
          }
          variables={[]}
          onLocalizationRemove={(ind) => {
            props.onLocalizationRemove(ind);
          }}
          onLocalizationUpdate={(ind, data) => {
            props.onLocalizationUpdate(ind, data);
          }}
        />
      </Modal>
    </>
  );
}
